// extracted by mini-css-extract-plugin
module.exports = {"modal-container":"Modal_modal-container__feqOq","modal":"Modal_modal__alQvB","error":"Modal_error__R12zI","closeBtn":"Modal_closeBtn__kTYvX"};